import axios from 'axios';
import { API_BASE_URL } from '../config/constants';

// The single axios instance. The /api prefix belongs in the call paths, not here —
// API_BASE_URL is the origin only.

const API = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('gs_token');
  if (token) config.headers['Authorization'] = `Token ${token}`;
  return config;
}, (error) => Promise.reject(error));

API.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 means the token is gone or expired — clear it and return to sign-in.
    // 403 is a live session lacking permission (a read-only user attempting a write);
    // that is handled where it happens, not by signing the user out.
    if (error.response?.status === 401) {
      localStorage.removeItem('gs_token');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default API;
